export default __webpack_public_path__ + "static/media/RunHorseLight_1_2.3cd55431.jpg";